export const fontMap = {
    // 勾选对号
    checked: '\uea4c',
    // 返回左箭头
    chevronBack: '\uea38',
    // 分享
    share: '\uea39',
    // 更多
    more: '\uea3a',
    // 关闭
    close: '\uea3b',
    // 客服
    chat: '\uea3c',
    // 搜索
    search: '\uea3d',
    // 向上人字形箭头
    chevronUp: '\uea41',
    // 向下人字形箭头
    chevronDown: '\uea40',
    // 加号
    plus: '\uea6f',
    // 加号 - 加粗
    plusBold: '\uea6e',
    // 小喇叭
    trumpet: '\uea42',
    // 向右人字形箭头
    chevronForward: '\uea3f',
    // 删除
    delete: '\uea43',
    // 编辑
    edit: '\uea48',
    // 电话
    phone: '\uea49',
    // 定位
    location: '\uea4a',
    // 定位点
    locate: '\uea4b',
    // 警示
    warning: '\uea4d',
    // 铃铛
    bell: '\uea4e',
    // 筛选
    filter: '\uea50',
    // 刷新
    refresh: '\uea52',
    // 通讯录
    addressBook: '\uea53',
    // 问号
    questionCircle: '\uea47',
    // 消息
    messageDot: '\uea54',
    // 消息提示
    messageTip: '\uea46',
    // 选中 - 线型
    checkedOutline: '\uea45',
    // 未选中 - 线型
    unCheckedOutline: '\uea44',
    // 选中 - 填充
    checkedFill: '\uea55',
    // 未选中 - 填充
    unCheckedFill: '\uea56',
    // 星星 - 填充
    starFill: '\uea58',
    // 足迹 - 填充
    pugFill: '\uea59',
    // 展开
    unfold: '\uea5b',
    // 收起
    collapse: '\uea5c',
    // 扫一扫
    scan: '\uea4f',
    // 设置
    setting: '\uea51',
    // 单程
    oneWay: '\uea5d',
    // 往返
    roundWay: '\uea5e',
    // 上箭头
    arrowUp: '\uea61',
    // 下箭头
    arrowDown: '\uea62',
    // 我的
    person: '\uea60',
    // 会员中心 - 一个皇冠👑
    crown: '\uea63',
    // 相机
    camera: '\uea64',
    // 视频
    video: '\uea65',
    // 减号 - 带圆框 - 移除
    remove: '\uea66',
    // 加号 - 带圆框 - 增加
    add: '\uea67',
    // 播放
    play: '\uea5f',
    // 心形 - 实心
    heartFill: '\uea6a',
    // 心形 - 空心
    heartOutline: '\uea6b',
    // 置顶
    goTop: '\uf3a4',
    // 添加 加粗 - 和上面的 plusBold 重复了
    addBold: '\uea6e',
    // 无障碍客房
    accessibleRooms: '\uf215',
    // 去程
    outTrip: '\uea80',
    // 返程
    retTrip: '\uea85'
};
